import React, { useState } from "react";
import RequestForm from "./request-form";
import DocumentsForm from "./documents-form";
import Swal from "sweetalert2";
import './withdrawals.css'

function WithdrawalsForms({master, subproduct, onCancel}) {
    const [activeForm, setActiveForm] = useState('request');
    const [isRequestSaved, setIsRequestSaved] = useState(false);  // Para manejar la habilitacion del boton de "Documentos"

    console.log(subproduct);

    const handleFormClick = (form) => {
        setActiveForm(form);
        //setSelectedSubproduct(null); // reinicia el subproducto para mostrar la tabla
    };

    const handleRequestSaved = () => {
        setIsRequestSaved(true);
    };

    const renderForm = () => {
        if (activeForm === 'request') return <RequestForm master={master} onSaved={handleRequestSaved} />;
        if (activeForm === 'documents') return <DocumentsForm master={master} />;
        return null;
    };

    const handleCancelWithdrawal = () => {
        Swal.fire({
            title: '¿Estás seguro que deseas cancelar el desistimiento?',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cerrar',
            customClass: {
                confirmButton: 'btn-amc-blue',
                cancelButton: 'btn-amc-pink',
                title: 'alert-title',
                popup: 'alert-bg'
            },
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
            // Aquí se cancela el desistimiento
            onCancel();
            }
        });
    };

    console.log(master);

    return(
        <>
            <div className="container-fluid">
                <div className="row mb-4">
                    {/* Botones para cambiar de formulario */}
                    <div className="col-6 d-flex gap-3 btns-forms">
                        <button onClick={() => handleFormClick('request')} className="btnn">Solicitud</button>
                        <button onClick={() => handleFormClick('documents')} className="btnn" disabled={!isRequestSaved}>Documentos</button>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        <button className='btnn' onClick={handleCancelWithdrawal} >Cancelar desistimiento</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Master:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Origen:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Destino:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Tipo de mercancía:</span> {master.number} </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Piezas Master:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Peso:</span> {master.weight} </p>
                    </div>
                    {subproduct && (
                        <>
                        <div className="col-3">
                            <p><span className="fw-bold">HBS:</span> {subproduct.hbs} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Piezas House:</span> {subproduct.piezas} </p>
                        </div>
                        </>
                    )}
                </div>
                {subproduct && (
                    <div className="row">
                        <div className="col-3">
                            <p><span className="fw-bold">Peso House:</span> {subproduct.peso} </p>
                        </div>
                    </div>
                )}

                {renderForm()}
            </div>
        </>
    )
}

export default WithdrawalsForms;